import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
   Button, ButtonToolbar, Modal, Alert,
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import Moment from 'moment';

import CommonService from '../../../services/CommonService';
import global from '../../../global';

class StoreReportModal extends PureComponent {
   static propTypes = {
      modal: PropTypes.bool,
      toggle: PropTypes.func.isRequired,
      handleSubmit: PropTypes.func,
      errorMsg: PropTypes.string,
   };

   static defaultProps = {
      modal: false,
      handleSubmit: (e) => {
         e.preventDefault();
         console.log('submitted');
      },
      errorMsg: '',
   };

   constructor(props) {
      super(props);
      this.state = {
          formdata: {},
      };
      this.isLoading = false;
      this.toggle = this.toggle.bind(this);
      this.expensesChange = this.expensesChange.bind(this);
      this.userdata = JSON.parse(localStorage.getItem('userData'));
   }

    componentDidMount() {
        this.isLoading = true;
        this.onLoadData();
    }

    componentWillReceiveProps(newProps) {
        if (newProps.modal) {
            this.onLoadData();
        }
    }

    async onLoadData(mdate = '') {
        try {
            const date = mdate !== '' ? mdate : new Date();
            const dateText = Moment(date).format('YYYY-MM-DD');

            const response = await CommonService.getRows(`storereportdisplay/locationid/${this.userdata.location_id}/reportdate/${dateText}`);
            if (this.isLoading && (response !== false || response !== '')) {
            this.setState({
                formdata: response,
            });
            }
        } catch (err) {
            console.log('Error: ', err.message);
            this.isLoading = false;
        }
    }

    handleChange = (e, fieldName = '') => {
      if (fieldName === 'tdate') {
        const date = new Date(e);
        this.setState(prevState => ({
          formdata: { ...prevState.formdata, reportDate: Moment(date).format('YYYY-MM-DD HH:mm:ss') },
        }));

        this.onLoadData(date);
      } else {
        const { name, value } = e.target;
        this.setState(prevState => ({
          formdata: { ...prevState.formdata, [name]: value },
        }));
      }
   }

    expensesChange = (e, type = 'remit') => {
        const { name, value } = e.target;
        const { formdata } = this.state;
        const { numberFormat, parseToNumber } = global;
        const value2 = value.replace(/[^0-9.]/g, '');

        if (type === 'remit') {
            const cashrem = (formdata.salescash + formdata.collectioncash) - value2;
            this.setState(prevState => ({
                formdata: {
                    ...prevState.formdata, remitcash: cashrem, cashvariance: cashrem, [name]: value2,
                },
            }));
        } else if (type === 'varcash') {
            const cashrem = formdata.remitcash - value2;
            const toremit = (formdata.chequeremitted ? parseToNumber(formdata.chequeremitted) : 0) + (value2 ? parseToNumber(value2) : 0);

            this.setState(prevState => ({
                formdata: {
                    ...prevState.formdata, cashvariance: cashrem, remittotal: numberFormat(toremit), [name]: value2,
                },
            }));
        } else if (type === 'varcheque') {
            const cashrem = formdata.remitcheque - value2;
            const toremit = (formdata.cashremitted ? parseToNumber(formdata.cashremitted) : 0) + (value2 ? parseToNumber(value2) : 0);

            this.setState(prevState => ({
                formdata: {
                    ...prevState.formdata, chequevariance: cashrem, remittotal: numberFormat(toremit), [name]: value2,
                },
            }));
        } else {
            this.setState(prevState => ({
                formdata: { ...prevState.formdata, [name]: value2 },
            }));
        }
    }

   toggle() {
      this.setState(prevState => ({ modal: !prevState.modal }));
   }

   render() {
      const {
         toggle, modal, handleSubmit, errorMsg,
      } = this.props;

      const { formdata } = this.state;
      const { numberFormat } = global;

      return (
         <div>
            <Modal
               isOpen={modal}
               className="modal-dialog--primary modal-dialog--header"
            >
               <div className="modal__header bg_blue">
                  <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
                  <h4 className="bold-text  modal__title">Daily Sales Report</h4>
               </div>
               <form onSubmit={handleSubmit} id="store_daily_report">
                  <div className="modal__body p-t-10">
                  { errorMsg && (
                     <div className="notif_msg">
                        <Alert color="danger" className="alert--colored">
                        <div className="alert__content">
                           <p>{errorMsg}</p>
                        </div>
                        </Alert>
                     </div>
                     )
                  }

                  <div className="form form--horizontal">
                    <div className="form__form-group border-bottom p-b-15 p-t-10">
                        <span className="form__form-group-label bold">Report Date <b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                        <div className="date-picker">
                            <DatePicker
                            name="reportDate"
                            selected={formdata.reportDate ? new Date(formdata.reportDate) : new Date()}
                            onChange={e => this.handleChange(e, 'tdate')}
                            />
                        </div>
                        </div>
                    </div>
                    {/* Sales */}
                    <div className="form__form-group m-b-7">
                        <span className="form__form-group-label"><strong>Total Sales</strong></span>
                        <div className="form__form-group-field">
                          <span>&#x20B1; <strong>{formdata.salestotal ? numberFormat(formdata.salestotal) : 0}</strong></span>
                          <input type="text" name="salestotal" value={formdata.salestotal ? numberFormat(formdata.salestotal) : 0} hidden readOnly />
                        </div>
                    </div>

                    <div className="form__form-group m-b-0">
                        <span className="form__form-group-label p-l-15">Cash</span>
                        <div className="form__form-group-field">
                          <span>&#x20B1; {formdata.salescash ? numberFormat(formdata.salescash) : 0}</span>
                          <input type="text" name="salescash" value={formdata.salescash ? numberFormat(formdata.salescash) : 0} hidden readOnly />
                        </div>
                    </div>

                    <div className="form__form-group m-b-20 border-bottom p-b-10">
                        <span className="form__form-group-label p-l-15">Cheque</span>
                        <div className="form__form-group-field">
                          <span>&#x20B1; {formdata.salescheque ? numberFormat(formdata.salescheque) : 0}</span>
                          <input type="text" name="salescheque" value={formdata.salescheque ? numberFormat(formdata.salescheque) : 0} hidden readOnly />
                        </div>
                    </div>

                    {/* Collection */}
                    <div className="form__form-group m-b-7">
                        <span className="form__form-group-label"><strong>Total Collection</strong></span>
                        <div className="form__form-group-field">
                        <span>&#x20B1; <strong>{formdata.collectiontotal ? numberFormat(formdata.collectiontotal) : 0}</strong></span>
                        <input type="text" name="collectiontotal" value={formdata.collectiontotal ? numberFormat(formdata.collectiontotal) : 0} hidden readOnly />
                        </div>
                    </div>

                    <div className="form__form-group m-b-0">
                        <span className="form__form-group-label p-l-15">Cash</span>
                        <div className="form__form-group-field">
                        <span>&#x20B1; {formdata.collectioncash ? numberFormat(formdata.collectioncash) : 0}</span>
                        <input type="text" name="collectioncash" value={formdata.collectioncash ? numberFormat(formdata.collectioncash) : 0} hidden readOnly />
                        </div>
                    </div>

                    <div className="form__form-group m-b-20 border-bottom p-b-10">
                        <span className="form__form-group-label p-l-15">Cheque</span>
                        <div className="form__form-group-field">
                        <span>&#x20B1; {formdata.collectioncheque ? numberFormat(formdata.collectioncheque) : 0}</span>
                        <input type="text" name="collectioncheque" value={formdata.collectioncheque ? numberFormat(formdata.collectioncheque) : 0} hidden readOnly />
                        </div>
                    </div>

                    <div className="form__form-group m-b-7">
                        <span className="form__form-group-label"><strong>Total AR</strong></span>
                        <div className="form__form-group-field">
                        <span>&#x20B1; <strong>{formdata.receivable ? numberFormat(formdata.receivable) : 0}</strong></span>
                        <input type="text" name="receivable" value={formdata.receivable ? numberFormat(formdata.receivable) : 0} hidden readOnly />
                        </div>
                    </div>

                    <div className="form__form-group m-b-7">
                        <span className="form__form-group-label"><strong>Total Bills &amp; Coins</strong> <b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                            <div className="form__form-group-icon p-l-0">&#x20B1; </div>
                            <input type="text" name="totalbills" value={formdata.totalbills ? numberFormat(formdata.totalbills) : ''} placeholder="Bills and coins..." onChange={e => this.expensesChange(e, 'number')} />
                        </div>
                    </div>

                    <div className="form__form-group m-b-15 border-bottom p-b-15">
                        <span className="form__form-group-label"><strong>Total Expenses</strong> <b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                            <div className="form__form-group-icon p-l-0">&#x20B1; </div>
                            <input type="text" name="totalexpenses" value={formdata.totalexpenses ? numberFormat(formdata.totalexpenses) : ''} onChange={e => this.expensesChange(e, 'remit')} placeholder="Expenses..." />
                        </div>
                    </div>

                    <div className="form__form-group m-b-4">
                        <span className="form__form-group-label"><strong>Cash to Remit</strong></span>
                        <div className="form__form-group-field">
                            <span className={`${formdata.remitcash < 0 ? 'text-red' : ''}`}>&#x20B1; <strong>{formdata.remitcash ? numberFormat(formdata.remitcash) : 0}</strong></span>
                            <input type="text" name="remitcash" value={formdata.remitcash ? numberFormat(formdata.remitcash) : 0} hidden readOnly />
                        </div>
                    </div>

                    <div className="form__form-group m-b-15">
                        <span className="form__form-group-label"><strong>Cheque to Remit</strong></span>
                        <div className="form__form-group-field">
                            <span>&#x20B1; <strong>{formdata.remitcheque ? numberFormat(formdata.remitcheque) : 0}</strong></span>
                            <input type="text" name="remitcheque" value={formdata.remitcheque ? numberFormat(formdata.remitcheque) : 0} hidden readOnly />
                        </div>
                    </div>

                    <div className="form__form-group m-b-7">
                        <span className="form__form-group-label"><strong>Total Remitted</strong></span>
                        <div className="form__form-group-field">
                            <span>&#x20B1; <strong>{formdata.remittotal ? numberFormat(formdata.remittotal) : 0}</strong></span>
                            <input type="text" name="remittotal" value={formdata.remittotal ? numberFormat(formdata.remittotal) : 0} hidden readOnly />
                        </div>
                    </div>

                    <div className="form__form-group m-b-7">
                        <span className="form__form-group-label p-l-15">Cash Remitted <b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                            <div className="form__form-group-icon p-l-0">&#x20B1; </div>
                            <input type="text" onChange={e => this.expensesChange(e, 'varcash')} name="cashremitted" defaultValue={formdata.cashremitted ? formdata.cashremitted : ''} placeholder="Cash remitted..." />
                        </div>
                    </div>

                    <div className="form__form-group m-b-15 border-bottom p-b-10">
                        <span className="form__form-group-label p-l-15">Cheque Remitted <b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                            <div className="form__form-group-icon p-l-0">&#x20B1; </div>
                            <input type="text" name="chequeremitted" value={formdata.chequeremitted ? numberFormat(formdata.chequeremitted) : ''} placeholder="Cheque remitted.." onChange={e => this.expensesChange(e, 'varcheque')} />
                        </div>
                    </div>

                    <div className="form__form-group m-b-7">
                        <span className="form__form-group-label"><strong>Cash Variance</strong></span>
                        <div className="form__form-group-field">
                            <span>&#x20B1; <strong>{formdata.cashvariance ? numberFormat(formdata.cashvariance) : 0}</strong></span>
                            <input type="text" name="cashvariance" value={formdata.cashvariance ? numberFormat(formdata.cashvariance) : 0} hidden readOnly />
                        </div>
                    </div>

                    <div className="form__form-group m-b-15">
                        <span className="form__form-group-label"><strong>Cheque Variance</strong></span>
                        <div className="form__form-group-field">
                            <span>&#x20B1; <strong>{formdata.chequevariance ? numberFormat(formdata.chequevariance) : 0}</strong></span>
                            <input type="text" name="chequevariance" value={formdata.chequevariance ? numberFormat(formdata.chequevariance) : 0} hidden readOnly />
                        </div>
                    </div>
                  </div>

                  <div className="form form--vertical m-t-10">
                     <div className="form__form-group m-b-7">
                        <span className="form__form-group-label"><strong>Note</strong></span>
                        <div className="form__form-group-field">
                           <textarea name="note" placeholder="Notes..." className="mh-150 no-resize" />
                        </div>
                     </div>
                  </div>
                  </div>
                  <ButtonToolbar className="modal__footer">
                     <Button color="primary">Submit</Button>
                     <Button onClick={toggle}>Cancel</Button>
                  </ButtonToolbar>
               </form>
            </Modal>
         </div>
      );
   }
}

export default reduxForm({
  form: 'stockForm',
})(withTranslation('common')(StoreReportModal));
